//项目所属企业统计
const dark_heading = "#c2c6dc";
export default function echartBar2() {
    return {
        legend: {
            borderRadius: 0,
            orient: "horizontal",
            x: "left",
            data: [
            ],
        },
        grid: {
            left: "8px",
            right: "8px",
            bottom: "0",
            containLabel: true,
        },
        tooltip: {
            show: true,
            backgroundColor: "rgba(0, 0, 0, .8)",

        },

        xAxis: [
            {
                type: "category",
                data: [],
                axisTick: {
                    alignWithLabel: true,
                },
                splitLine: {
                    show: false,
                },
                axisLabel: {
                    color: dark_heading,
                },
                axisLine: {
                    show: true,
                    color: dark_heading,

                    lineStyle: {
                        color: dark_heading,
                    },
                },
            },
        ],
        yAxis: [
            {
                type: "value",

                axisLabel: {
                    color: dark_heading,
                    formatter: "数量{value}",
                },
                axisLine: {
                    show: true,
                    color: dark_heading,

                    lineStyle: {
                        color: dark_heading,
                    },
                },
                interval: 25,
                splitLine: {
                    show: false,
                    interval: "auto",
                },
            },
        ],

        series: [
        ],
    }
};
